



import { BaseEntityResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEntitiesResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseDataResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseResponse } from '@m4u-angular/base/entities/BaseEntities';
import { GenericListEntity } from '@m4u-angular/base/entities/BaseEntities';
import { DataGroupInfo } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEndpoint } from '@m4u-angular/base/endpoint/BaseEndpoint';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { APIGatewayService } from '@m4u-angular/core/gateway/APIGateway.service';
import { EnumRequestProgressTracking } from '@m4u-angular/core/framework/sysenums.enum';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaymentRequest } from './../entities/paymentrequest.entity';
import { PaymentRequestStep } from './../entities/paymentrequest.entity';
import { BaseDocument } from './../entities/basedocument.entity';
import { PaymentConfigView } from './../views/paymentconfig.view';
import { PaymentRequestResponseParams } from './../params/paymentrequestresponse.param';
import { PaymentRequestListParams } from './../params/paymentrequestlist.param';
import { MakePaymentParams } from './../params/makepayment.param';
import { ConfirmPaymentRequestParams } from './../params/confirmpaymentrequest.param';
@Injectable()
export class PaymentRequestEndpoint extends BaseEndpointCRUD<PaymentRequest>
{
    constructor(api: APIGatewayService) {super("PaymentRequest", api);}
	

    public  ListEx(oParams: PaymentRequestListParams, oOptions: DataLoadOptions) : Observable<BaseEntitiesResponse<PaymentRequest>>
	{
		return this.api.ExecutePostAction(this.ControllerName, 'ListEx', oParams,  {oOptions: oOptions} );
    }

    public  GetSteps(iEntryID: number) : Observable<BaseEntitiesResponse<PaymentRequestStep>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetSteps',  {iEntryID: iEntryID} );
    }

    public  GetLinesDocuments(iEntryID: number) : Observable<BaseEntitiesResponse<BaseDocument>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetLinesDocuments',  {iEntryID: iEntryID} );
    }

    public  ResolveStatus(iEntryID: number) : Observable<BaseResponse>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'ResolveStatus',  {iEntryID: iEntryID} );
    }

    public  GetPaymentConfig(iDocNum: number, iObjectType: number) : Observable<BaseEntityResponse<PaymentConfigView>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetPaymentConfig',  {iDocNum: iDocNum, iObjectType: iObjectType} );
    }

    public  Send(oParams: MakePaymentParams) : Observable<BaseEntityResponse<PaymentRequest>>
	{
		return this.api.ExecutePostAction(this.ControllerName, 'Send', oParams,  undefined );
    }

    public  Confirm(oParams: ConfirmPaymentRequestParams) : Observable<PaymentRequestResponseParams>
	{
		return this.api.ExecutePostAction(this.ControllerName, 'Confirm', oParams,  undefined );
    }

    public  ConfirmPayment(paymentRequestID: number) : Observable<PaymentRequestResponseParams>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'ConfirmPayment',  {paymentRequestID: paymentRequestID} );
    }

    public  GetPaymentRequest(privateRequestID: string) : Observable<BaseEntityResponse<PaymentRequest>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetPaymentRequest',  {privateRequestID: privateRequestID} );
    }

    public  Execute(oParams: MakePaymentParams) : Observable<PaymentRequestResponseParams>
	{
		return this.api.ExecutePostAction(this.ControllerName, 'Execute', oParams,  undefined );
    }
}

